import './Landing.css';

function Landing(){
    return(
        <div className="retro-heading" id="home">
            RETRO
        </div>
    )
}

export default Landing;